// import { useEffect } from 'react';
// import PropTypes from 'prop-types';
// import { useNavigate } from 'react-router-dom';

// // project imports
// import useAuth from 'hooks/useAuth';

// const AuthGuard = ({ children }) => {
// 	const { isLoggedIn } = useAuth();
// 	const navigate = useNavigate();

// 	useEffect(() => {
// 		if (!isLoggedIn) {
// 			navigate('/auth/login', { replace: true });
// 		}
// 	}, [isLoggedIn, navigate]);

// 	return children;
// };

// AuthGuard.propTypes = {
// 	children: PropTypes.node
// };

// export default AuthGuard;

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux'; // 1. We need useSelector

// project imports
// We no longer need the useAuth hook here.
// import useAuth from 'hooks/useAuth';
// 2. We import the selector directly from the Redux slice.
import { selectUser } from 'store/user/userSlice';

const AuthGuard = ({ children }) => {
    // 3. We bypass the useAuth hook and get the user state DIRECTLY from Redux.
    const { isLoggedIn, isInitialized } = useSelector(selectUser);
    const navigate = useNavigate();

    useEffect(() => {
        // 4. We now wait for the session to be initialized AND check the login status.
        // This prevents any redirects from happening before Firebase has had a chance to check the session.
        if (isInitialized && !isLoggedIn) {
            navigate('/auth/login', { replace: true });
        }
    }, [isInitialized, isLoggedIn, navigate]);

    // 5. If the session is not yet initialized, we render nothing to prevent any further rendering down the tree.
    // Your FirebaseContext will show a <Loader /> anyway.
    if (!isInitialized) {
        return null;
    }

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;